module.exports = __webpack_public_path__ + "img/about@2x.5f3e3579.jpg";